const roles = {
    VIEWER: {
        name: 'viewer',
        value: 0
    },
    OWNER: {
        name: 'owner',
        value: 1
    },
    DEVELOPER: {
        name: 'developer',
        value: 2
    },
    ADMIN: {
        name: 'admin',
        value: 3
    }
};

export default Object.freeze(roles);
